import { render, staticRenderFns } from "./OurWinesComponent.vue?vue&type=template&id=ae970bb6&"
import script from "./OurWinesComponent.vue?vue&type=script&lang=js&"
export * from "./OurWinesComponent.vue?vue&type=script&lang=js&"
import style0 from "./OurWinesComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports